import { useRouteDependencies } from '@townsquare/router/primitives/dependencies';
import { generatePath } from '@townsquare/router/primitives/path';
import { teamsSettingsRoute } from '@townsquare/routes/teams-settings-view';
import { createSearchParamsFromScratch } from '@townsquare/search-params';

import { DEFAULT_TEAM_SCREEN_NEXT, type ScreenType } from '../config/types';

export const useTeamSettingsPath = (
	screen?: ScreenType,
	additionalParams?: Record<string, string>,
): string => {
	const routeDependencies = useRouteDependencies();

	const basePath = generatePath(teamsSettingsRoute, routeDependencies);
	const searchParams = createSearchParamsFromScratch({
		screen: screen ?? DEFAULT_TEAM_SCREEN_NEXT,
		...additionalParams,
	});
	return `${basePath}?${searchParams.toString()}`;
};
